import { useState, useEffect } from 'react';
import DateSelector from '../../dumb/form/DateSelector';
import MultiSelect  from '../../dumb/form/MultiSelect';

function CourseForm({ courses, batches, onSelectCourses, onSelectBatches, onSelectStartDate, onSelectEndDate }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '100px' }}>
            <div className="form-group">
                <label> <b> Select Courses </b> </label>
                <MultiSelect
                    options={courses}
                    value={course => course.courseName}
                    display={course => course.courseName}
                    onChange={selectedCourses => onSelectCourses(selectedCourses)}
                />
            </div>
            <div className="form-group">
                <label style={{marginRight: '20px'}}> Select Batches </label>
                <MultiSelect
                    options={batches}
                    value={batch => batch.batchName}
                    display={batch => `${batch.batchName}`}
                    onChange={selectedBatches => onSelectBatches(selectedBatches)}
                />
            </div>
            <div className="form-group">
                <label> Select Start Date (optional) </label>
                <DateSelector
                    selectDate={startDate => onSelectStartDate(startDate)}
                />
            </div>
            <div className="form-group">
                <label> Select End Date (optional) </label>
                <DateSelector
                    selectDate={endDate => onSelectEndDate(endDate)}
                />
            </div>
        </div>
    )
}

export default CourseForm;